/** @jsx jsx */
import { Box, Container, Grid, Heading, jsx, Text } from 'theme-ui'
import EventCard from '~/components/Event/Card'

const EventListSection = ({ title, description, events }) => {
  return (
    <Box bg="background" pt={[6, 7, 9]} pb={[7, 8, 10]}>
      <Container>
        <Grid columns={[1, 12]} sx={{ rowGap: '0' }}>
          <Box
            sx={{
              gridColumn: [null, '2 / 12', '3 / 11'],
              textAlign: 'center',
            }}
          >
            <Heading as="h1" mb={[2, 3]} variant="title1">
              {title}
            </Heading>
            {description && (
              <Box
                variant="text.body1"
                dangerouslySetInnerHTML={{
                  __html: description.childMarkdownRemark.html,
                }}
              />
            )}
          </Box>
          <Box sx={{ gridColumn: [null, '1 / -1', null, '2 / 12'] }}>
            {!events && (
              <Text
                as="p"
                mt={[3, 4, 6]}
                variant="body1"
                sx={{ textAlign: 'center' }}
              >
                There are currently no upcoming events. Check back soon!
              </Text>
            )}
            {events && (
              <Box mt={[6, 7, 9]}>
                <Grid columns={1} sx={{ rowGap: 5 }}>
                  {events.map((event, index) => (
                    <EventCard key={`event-${index}`} event={event} />
                  ))}
                </Grid>
              </Box>
            )}
          </Box>
        </Grid>
      </Container>
    </Box>
  )
}

export default EventListSection
